webpackJsonp([172923708597564],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 350:
/***/ (function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(186);
	var each = __webpack_require__(103).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(184);
	var Util = __webpack_require__(103);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(185);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	'use strict';
	
	exports.atob = self.atob.bind(self);
	exports.btoa = self.btoa.bind(self);


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(259);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(438);
	var objectAssign = __webpack_require__(6);
	var decodeComponent = __webpack_require__(350);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(142);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(436);

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(435);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(142);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(433);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(253);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(181);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(437);
	
	var _dots = __webpack_require__(432);
	
	var _arrows = __webpack_require__(431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(255);
	
	var _helpers = __webpack_require__(142);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(255);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(35);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(434);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(188);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(253);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(172);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(187);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(6);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(43);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(254);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _close = __webpack_require__(260);
	
	var _close2 = _interopRequireDefault(_close);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorSelector = function (_React$Component) {
	  _inherits(ColorSelector, _React$Component);
	
	  function ColorSelector(props) {
	    _classCallCheck(this, ColorSelector);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      bitsColors: _this.props.bits[_this.props.slide].colors
	    };
	    return _this;
	  }
	
	  ColorSelector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.slide != this.props.slide) {
	      this.setState({
	        bitsColors: this.props.bits[this.props.slide].colors
	      });
	    }
	  };
	
	  ColorSelector.prototype.renderColor = function renderColor(color, index) {
	    var _this2 = this;
	
	    var checked = this.props.color.code === color.code;
	    var colorSwatchUrl = color.swatch.resize.src;
	    var classChecked = checked ? "--checked" : "";
	    return _react2.default.createElement(
	      'label',
	      { key: color.sku },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'button--round color-selector__button' + classChecked
	        },
	        _react2.default.createElement('div', { style: { backgroundImage: 'url(\'' + colorSwatchUrl + '\')' } }),
	        _react2.default.createElement('input', {
	          name: color.code,
	          className: 'color-selector__checkbox',
	          type: 'checkbox',
	          checked: checked,
	          onChange: function onChange() {
	            return _this2.props.handleColorChange(color, index);
	          }
	        })
	      )
	    );
	  };
	
	  ColorSelector.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'color-selector__dropdown' + this.props.cssModifier },
	      _react2.default.createElement('img', {
	        src: _close2.default,
	        className: 'button--close',
	        onClick: function onClick() {
	          return _this3.props.handleCloseModal();
	        }
	      }),
	      _react2.default.createElement(
	        'form',
	        { className: 'color-selector__dropdown__container' },
	        this.state.bitsColors.map(function (color, i) {
	          return _this3.renderColor(color, i);
	        })
	      )
	    );
	  };
	
	  return ColorSelector;
	}(_react2.default.Component);
	
	exports.default = ColorSelector;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(254);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _arrowCircleLeft = __webpack_require__(296);
	
	var _arrowCircleLeft2 = _interopRequireDefault(_arrowCircleLeft);
	
	var _arrowCircleRight = __webpack_require__(297);
	
	var _arrowCircleRight2 = _interopRequireDefault(_arrowCircleRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InterchangeabilitySlider = function (_React$Component) {
	  _inherits(InterchangeabilitySlider, _React$Component);
	
	  function InterchangeabilitySlider() {
	    _classCallCheck(this, InterchangeabilitySlider);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  InterchangeabilitySlider.prototype.optionalColors = function optionalColors() {
	    var _this2 = this;
	
	    return this.props.optionalBits.map(function (bit, index) {
	      return bit.colors[index === _this2.state.optionalBitIndex ? _this2.state.optionalColorIndex : 0];
	    });
	  };
	
	  InterchangeabilitySlider.prototype.renderSlide = function renderSlide(image) {
	    return _react2.default.createElement(
	      'div',
	      { key: image.url },
	      _react2.default.createElement('img', { src: this.props.isTall ? image.tall.src : image.normal.src })
	    );
	  };
	
	  InterchangeabilitySlider.prototype.renderBaseSliderArrows = function renderBaseSliderArrows() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'slick-slider__arrow--basebits slick-slider--prev' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'slick-slider__arrow--prev',
	            onClick: function onClick() {
	              _this3.baseSlider.slickPrev();
	            }
	          },
	          ' ',
	          _react2.default.createElement('img', { src: _arrowCircleLeft2.default }),
	          ' '
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'slick-slider__arrow__text' },
	          this.props.prevBaseBit.name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slick-slider__arrow--basebits slick-slider--next' },
	        _react2.default.createElement(
	          'p',
	          { className: 'slick-slider__arrow__text' },
	          this.props.nextBaseBit.name
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'slick-slider__arrow--next',
	            onClick: function onClick() {
	              _this3.baseSlider.slickNext();
	            }
	          },
	          ' ',
	          _react2.default.createElement('img', { src: _arrowCircleRight2.default }),
	          ' '
	        )
	      )
	    );
	  };
	
	  InterchangeabilitySlider.prototype.renderTopSliderArrows = function renderTopSliderArrows() {
	    var _this4 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'slick-slider__arrow--optionalbits slick-slider--prev' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'slick-slider__arrow--prev',
	            onClick: function onClick() {
	              _this4.topSlider.slickPrev();
	            }
	          },
	          ' ',
	          _react2.default.createElement('img', { src: _arrowCircleLeft2.default }),
	          ' '
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'slick-slider__arrow__text' },
	          this.props.prevTopBit.name
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'slick-slider__arrow--optionalbits slick-slider--next' },
	        _react2.default.createElement(
	          'p',
	          { className: 'slick-slider__arrow__text' },
	          this.props.nextTopBit.name
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'slick-slider__arrow--next',
	            onClick: function onClick() {
	              _this4.topSlider.slickNext();
	            }
	          },
	          ' ',
	          _react2.default.createElement('img', { src: _arrowCircleRight2.default }),
	          ' '
	        )
	      )
	    );
	  };
	
	  InterchangeabilitySlider.prototype.renderBaseSlider = function renderBaseSlider(baseSettings) {
	    var _this5 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'base-bits-slider' },
	      _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({}, baseSettings, {
	          ref: function ref(c) {
	            return _this5.baseSlider = c;
	          }
	        }),
	        this.props.baseBitsImages.length > 0 && this.props.baseBitsImages.map(function (i) {
	          return _this5.renderSlide(i);
	        })
	      ),
	      this.props.baseBitsImages.length > 1 && this.renderBaseSliderArrows()
	    );
	  };
	
	  InterchangeabilitySlider.prototype.renderTopSlider = function renderTopSlider(topSettings) {
	    var _this6 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'optional-bits-slider' },
	      _react2.default.createElement(
	        _reactSlick2.default,
	        _extends({}, topSettings, { ref: function ref(c) {
	            return _this6.topSlider = c;
	          } }),
	        this.props.optionalBitsImages.length > 0 && this.props.optionalBitsImages.map(function (i) {
	          return _this6.renderSlide(i);
	        })
	      ),
	      this.props.optionalBitsImages.length > 1 && this.renderTopSliderArrows()
	    );
	  };
	
	  InterchangeabilitySlider.prototype.render = function render() {
	    var _this7 = this;
	
	    var _props = this.props,
	        optionalBitsImages = _props.optionalBitsImages,
	        baseBitsImages = _props.baseBitsImages;
	
	
	    var responsive = [{
	      breakpoint: 450,
	      settings: {
	        centerPadding: '50px'
	      }
	    }];
	
	    var min = 500;
	    var max = 2200;
	
	    for (var breakpoint = min; breakpoint < max; breakpoint += 50) {
	      responsive.push({
	        breakpoint: breakpoint,
	        settings: {
	          centerPadding: Math.floor(breakpoint * (0.15 + 0.15 * (breakpoint - min) / (max - min))) + 'px'
	        }
	      });
	    }
	
	    var settings = {
	      infinite: true,
	      slidesToShow: 1,
	      centerMode: true,
	      arrows: false,
	      responsive: responsive
	    };
	
	    var singleImageSettings = {
	      infinite: false,
	      slidesToShow: 1,
	      centerMode: true,
	      arrows: false,
	      responsive: responsive
	    };
	
	    var baseSettings = _extends({}, settings, {
	      afterChange: function afterChange(currentSlide) {
	        _this7.props.changeSlide(currentSlide, true);
	      }
	    });
	    var topSettings = _extends({}, settings, {
	      afterChange: function afterChange(currentSlide) {
	        _this7.props.changeSlide(currentSlide, false);
	      }
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'slider-container' },
	      baseBitsImages.length > 1 ? this.renderBaseSlider(baseSettings) : this.renderBaseSlider(singleImageSettings),
	      optionalBitsImages.length > 0 && optionalBitsImages.length > 1 ? this.renderTopSlider(topSettings) : this.renderTopSlider(singleImageSettings)
	    );
	  };
	
	  return InterchangeabilitySlider;
	}(_react2.default.Component);
	
	exports.default = InterchangeabilitySlider;
	module.exports = exports['default'];

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTransitionStyle = __webpack_require__(30);
	
	var _getTransitionStyle2 = _interopRequireDefault(_getTransitionStyle);
	
	var _logo_white = __webpack_require__(446);
	
	var _logo_white2 = _interopRequireDefault(_logo_white);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      transition = _ref.transition,
	      title = _ref.title;
	
	  var delay = 1000;
	  var status = transition ? transition.status : "entering";
	
	  var titleAppearsFromBottom = (0, _getTransitionStyle2.default)(status, 800, 0, 'textAppearsNoExiting');
	
	  var lineTransitionLeft = (0, _getTransitionStyle2.default)(status, 1000, delay, 'introLineTransitionLeft');
	
	  var lineTransitionRight = (0, _getTransitionStyle2.default)(status, 1000, delay, 'introLineTransitionRight');
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'intro' },
	    _react2.default.createElement(
	      'div',
	      { className: 'intro__container' },
	      _react2.default.createElement('div', { className: 'transition__line--left', style: lineTransitionLeft }),
	      _react2.default.createElement('div', { className: 'transition__line--right', style: lineTransitionRight }),
	      _react2.default.createElement(
	        'div',
	        { className: 'intro__title--interchangeability', style: titleAppearsFromBottom },
	        title
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(154);
	
	var _countryList = __webpack_require__(153);
	
	var _countryList2 = _interopRequireDefault(_countryList);
	
	var _request = __webpack_require__(144);
	
	var _Field = __webpack_require__(112);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _i18n = __webpack_require__(171);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	__webpack_require__(170);
	
	var _RequestModelForm = __webpack_require__(143);
	
	var _reactIntl = __webpack_require__(20);
	
	var _Alert = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RequestInfoForm = function (_React$Component) {
	  _inherits(RequestInfoForm, _React$Component);
	
	  function RequestInfoForm() {
	    _classCallCheck(this, RequestInfoForm);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RequestInfoForm.prototype.render = function render() {
	    var _React$createElement,
	        _this2 = this;
	
	    var _props = this.props,
	        handleSubmit = _props.handleSubmit,
	        isSubmitting = _props.isSubmitting,
	        product = _props.product,
	        productUrl = _props.productUrl,
	        sku = _props.sku,
	        price = _props.price;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'Modal__title' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requestInfoForm.title' })
	      ),
	      _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          'p',
	          { className: 'Modal__caption' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requestInfoForm.description' })
	        ),
	        _react2.default.createElement('input', (_React$createElement = { type: 'text' }, _React$createElement['type'] = 'hidden', _React$createElement.value = productUrl, _React$createElement)),
	        _react2.default.createElement('img', { src: productUrl }),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__field' },
	          _react2.default.createElement(
	            'label',
	            { className: 'form__label' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.product' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'form__value' },
	            _react2.default.createElement('input', { type: 'text', readonly: true, value: product })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              'label',
	              { className: 'form__label' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.sku' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form__value' },
	              _react2.default.createElement('input', { type: 'text', readonly: true, value: sku })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              'label',
	              { className: 'form__label' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.price' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form__value' },
	              _react2.default.createElement('input', { type: 'text', readonly: true, value: price })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'name' }, this.props),
	              _react2.default.createElement('input', { type: 'text' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'company' }, this.props),
	              _react2.default.createElement('input', { type: 'text' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'job' }, this.props),
	              _react2.default.createElement(
	                'select',
	                null,
	                _react2.default.createElement('option', null),
	                _RequestModelForm.occupations.map(function (value) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: value, value: value },
	                    _this2.props.intl.formatMessage({ id: 'form.job.' + value })
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'country' }, this.props),
	              _react2.default.createElement(
	                'select',
	                null,
	                _react2.default.createElement('option', null),
	                (0, _countryList2.default)().getNames().map(function (value) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: value, value: value },
	                    value
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'email' }, this.props),
	              _react2.default.createElement('input', { type: 'email' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid__item--half' },
	            _react2.default.createElement(
	              _Field2.default,
	              _extends({ name: 'phoneNumber' }, this.props),
	              _react2.default.createElement('input', { type: 'tel' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Field2.default,
	          _extends({ name: 'message' }, this.props),
	          _react2.default.createElement('textarea', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__field' },
	          _react2.default.createElement(
	            'label',
	            { className: 'form__label', htmlFor: 'newsletter' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.newsletter' })
	          ),
	          _react2.default.createElement('input', { type: 'checkbox', className: 'form__checkbox', defaultChecked: true,
	            onChange: this.props.handleChange, value: 'newsletter', name: 'newsletter'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'form__field' },
	          _react2.default.createElement(
	            'label',
	            { className: 'form__label', htmlFor: 'privacy' },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.iHaveRead' })
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'iubenda-nostyle no-brand iubenda-embed form__strong',
	              title: 'Privacy Policy',
	              href: 'https://www.iubenda.com/privacy-policy/' + _i18n2.default.t('iubendaId'),
	              target: '_blank'
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'form.privacy' })
	          ),
	          _react2.default.createElement('input', { type: 'checkbox', className: 'form__checkbox', required: 'true', defaultChecked: true })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'button--dark', disabled: isSubmitting },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'requestInfoForm.button' })
	        )
	      )
	    );
	  };
	
	  return RequestInfoForm;
	}(_react2.default.Component);
	
	var config = {
	  mapPropsToValues: function mapPropsToValues(props) {
	    return {
	      name: '',
	      country: '',
	      job: '',
	      email: '',
	      company: '',
	      phoneNumber: '',
	      message: '',
	      newsletter: true
	    };
	  },
	  handleSubmit: function handleSubmit(values, _ref) {
	    var props = _ref.props,
	        setSubmitting = _ref.setSubmitting,
	        setErrors = _ref.setErrors;
	
	    (0, _request.post)('https://ieidf2eyel.execute-api.us-east-1.amazonaws.com/dev/infoRequest/create', _extends({}, values, { locale: props.intl.locale, product: props.product,
	      price: props.price, sku: props.sku, productUrl: props.productImageEmailUrl })).then(function (result) {
	      setSubmitting(false);
	      setErrors({});
	      props.alert.success('requestInfoForm.success');
	      props.onSubmit();
	    }).catch(function (error) {
	      props.alert.error('requestInfoForm.error');
	      setSubmitting(false);
	      if (error.details) {
	        setErrors(error.details.reduce(function (acc, error) {
	          var _extends2;
	
	          return _extends({}, acc, (_extends2 = {}, _extends2[error.path[0]] = error.message, _extends2));
	        }, {}));
	      }
	    }), values["newsletter"] && (0, _request.post)('https://app.mailerlite.com/webforms/submit/n0h5i8?fields[email]=' + values["email"] + '&fields[name]=' + values["name"] + '&ml-submit=1&ajax=1&_=1518789895602', { "fields[email]": values["email"],
	      "fields[name]": values["name"] }).then(function (result) {
	      setSubmitting(false);
	      setErrors({});
	      props.alert.success('newsletterForm.success');
	    }).catch(function (error) {
	      props.alert.error('newsletterForm.error');
	      setSubmitting(false);
	      if (error.details) {
	        setErrors(error.details.reduce(function (acc, error) {
	          var _extends3;
	
	          return _extends({}, acc, (_extends3 = {}, _extends3[error.path[0]] = error.message, _extends3));
	        }, {}));
	      }
	    });
	  }
	};
	
	exports.default = (0, _Alert.withAlert)((0, _reactIntl.injectIntl)((0, _formik.withFormik)(config)(RequestInfoForm)));
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InterchangeabilitySlider = __webpack_require__(300);
	
	var _InterchangeabilitySlider2 = _interopRequireDefault(_InterchangeabilitySlider);
	
	var _ColorSelector = __webpack_require__(299);
	
	var _ColorSelector2 = _interopRequireDefault(_ColorSelector);
	
	var _RequestInfoForm = __webpack_require__(302);
	
	var _RequestInfoForm2 = _interopRequireDefault(_RequestInfoForm);
	
	var _RequestModelForm = __webpack_require__(143);
	
	var _RequestModelForm2 = _interopRequireDefault(_RequestModelForm);
	
	var _Modal = __webpack_require__(262);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _arrowLeft = __webpack_require__(442);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(444);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _arrowLeftWhite = __webpack_require__(441);
	
	var _arrowLeftWhite2 = _interopRequireDefault(_arrowLeftWhite);
	
	var _arrowRightWhite = __webpack_require__(443);
	
	var _arrowRightWhite2 = _interopRequireDefault(_arrowRightWhite);
	
	var _reactIntl = __webpack_require__(20);
	
	var _isomorphicBase = __webpack_require__(369);
	
	var _queryString = __webpack_require__(409);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _close = __webpack_require__(260);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _plus = __webpack_require__(447);
	
	var _plus2 = _interopRequireDefault(_plus);
	
	var _closeCircle = __webpack_require__(445);
	
	var _closeCircle2 = _interopRequireDefault(_closeCircle);
	
	var _test = __webpack_require__(448);
	
	var _test2 = _interopRequireDefault(_test);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import AccessoriesModal from '../components/AccessoriesModal'
	
	
	var WorkTable = function (_React$Component) {
	  _inherits(WorkTable, _React$Component);
	
	  function WorkTable(props) {
	    _classCallCheck(this, WorkTable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      baseBitIndex: 0,
	      optionalBitIndex: 0,
	      baseColorIndex: 0,
	      optionalColorIndex: 0,
	      modal: null,
	      accessoriesOn: false,
	      skinImage: _this.props.optionalBits[0] && _this.props.optionalBits[0].mysecondskinPreview ? _this.props.optionalBits[0].mysecondskinPreview.image.resize.src : null,
	      padImage: _this.props.optionalBits[0] && _this.props.optionalBits[0].softpadPreview ? _this.props.optionalBits[0].softpadPreview.image.resize.src : null
	    };
	    return _this;
	  }
	
	  WorkTable.prototype.currentBaseBit = function currentBaseBit() {
	    return this.props.baseBits[this.state.baseBitIndex];
	  };
	
	  WorkTable.prototype.currentOptionalBit = function currentOptionalBit() {
	    return this.props.optionalBits[this.state.optionalBitIndex];
	  };
	
	  WorkTable.prototype.baseColor = function baseColor() {
	    return this.currentBaseBit().colors[this.state.baseColorIndex];
	  };
	
	  WorkTable.prototype.optionalColor = function optionalColor() {
	    return this.currentOptionalBit() && this.currentOptionalBit().colors[this.state.optionalColorIndex];
	  };
	
	  WorkTable.prototype.baseColors = function baseColors() {
	    var _this2 = this;
	
	    return this.props.baseBits.map(function (bit, index) {
	      return bit.colors[index === _this2.state.baseBitIndex ? _this2.state.baseColorIndex : 0];
	    });
	  };
	
	  WorkTable.prototype.optionalColors = function optionalColors() {
	    var _state = this.state,
	        optionalBitIndex = _state.optionalBitIndex,
	        optionalColorIndex = _state.optionalColorIndex,
	        modal = _state.modal;
	
	    return this.props.optionalBits.map(function (bit, index) {
	      return bit.colors[index === optionalBitIndex ? optionalColorIndex : 0];
	    });
	  };
	
	  WorkTable.prototype.nextBaseBit = function nextBaseBit() {
	    var baseBits = this.props.baseBits;
	    var index = this.state.baseBitIndex;
	
	    return baseBits[index == baseBits.length - 1 ? 0 : index + 1];
	  };
	
	  WorkTable.prototype.nextOptionalBit = function nextOptionalBit() {
	    var optionalBits = this.props.optionalBits;
	    var index = this.state.optionalBitIndex;
	
	    return optionalBits[index == optionalBits.length - 1 ? 0 : index + 1];
	  };
	
	  WorkTable.prototype.prevBaseBit = function prevBaseBit() {
	    var baseBits = this.props.baseBits;
	    var index = this.state.baseBitIndex;
	
	    return baseBits[index == 0 ? baseBits.length - 1 : index - 1];
	  };
	
	  WorkTable.prototype.prevOptionalBit = function prevOptionalBit() {
	    var optionalBits = this.props.optionalBits;
	    var index = this.state.optionalBitIndex;
	
	    return optionalBits[index == 0 ? optionalBits.length - 1 : index - 1];
	  };
	
	  WorkTable.prototype.productName = function productName() {
	    return [this.currentBaseBit(), this.baseColor()].filter(function (x) {
	      return x;
	    }).map(function (x) {
	      return x.name;
	    }).join(' ') + ' / ' + [this.currentOptionalBit(), this.optionalColor()].filter(function (x) {
	      return x;
	    }).map(function (x) {
	      return x.name;
	    }).join(' ');
	  };
	
	  WorkTable.prototype.productPrice = function productPrice() {
	    var defaultBase = this.currentBaseBit().defaultPrice ? this.currentBaseBit().defaultPrice : 0;
	    var defaultOptional = this.currentOptionalBit() && this.currentOptionalBit().defaultPrice ? this.currentOptionalBit().defaultPrice : 0;
	    var basePrice = this.baseColor().price ? this.baseColor().price : defaultBase;
	    var optionalPrice = this.optionalColor() && this.optionalColor().price ? this.optionalColor().price : defaultOptional;
	    // const accessoryPrice = this.currentOptionalBit().defaultPrice ? this.currentOptionalBit().defaultPrice : 0
	    return basePrice + optionalPrice;
	  };
	
	  WorkTable.prototype.productSku = function productSku() {
	    return [this.baseColor(), this.optionalColor()].filter(function (x) {
	      return x;
	    }).map(function (x) {
	      return x.sku;
	    }).join('-');
	  };
	
	  WorkTable.prototype.productImageUrl = function productImageUrl() {
	    var crop = this.props.isTall ? '300,400,840,1150' : '300,400,840,900';
	
	    var productImageUrl = this.baseColor().bitImage.url + '?rect=' + crop + '&h=200';
	
	    if (this.optionalColor()) {
	      productImageUrl += '&mark64=' + (0, _isomorphicBase.btoa)(this.optionalColor().bitImage.url + '?rect=' + crop + '&h=200') + '&markalign=middle,center';
	    }
	
	    return productImageUrl;
	  };
	
	  WorkTable.prototype.productImageEmailUrl = function productImageEmailUrl() {
	    var crop = this.props.isTall ? '840,1150' : '840,900';
	
	    var productImageUrl = this.baseColor().bitImage.url + '?h=500';
	
	    if (this.optionalColor()) {
	      productImageUrl += '&mark64=' + (0, _isomorphicBase.btoa)(this.optionalColor().bitImage.url + '?&h=500') + '&markalign=middle,center';
	    }
	
	    return productImageUrl;
	  };
	
	  WorkTable.prototype.getId = function getId(bit) {
	    return bit ? bit.id.match(/[0-9]+/)[0] : '';
	  };
	
	  WorkTable.prototype.productShareUrl = function productShareUrl() {
	    var query = _queryString2.default.stringify({
	      optionalBit: this.getId(this.currentOptionalBit()),
	      optionalColor: this.getId(this.optionalColor()),
	      baseBit: this.getId(this.currentBaseBit()),
	      baseColor: this.getId(this.baseColor())
	    });
	
	    return 'https://www.kubikoff.com/chair?' + query;
	  };
	
	  WorkTable.prototype.handleCloseModal = function handleCloseModal() {
	    this.setState({ modal: null });
	  };
	
	  WorkTable.prototype.handleColorChange = function handleColorChange(index, isBase) {
	    isBase ? this.setState({ baseColorIndex: index }) : this.setState({ optionalColorIndex: index });
	  };
	
	  WorkTable.prototype.handleChangeBit = function handleChangeBit(bitIndex, isBase) {
	    this.handleCloseModal();
	    var currentOptionalBit = this.props.optionalBits[bitIndex];
	
	    var softpadPreview = !isBase && currentOptionalBit.softpadPreview ? currentOptionalBit.softpadPreview.image.resize.src : null;
	
	    var mysecondskinPreview = !isBase && currentOptionalBit.mysecondskinPreview ? currentOptionalBit.mysecondskinPreview.image.resize.src : null;
	
	    isBase ? this.setState({ baseBitIndex: bitIndex, baseColorIndex: 0 }) : this.setState({ optionalBitIndex: bitIndex,
	      optionalColorIndex: 0,
	      padImage: softpadPreview, skinImage: mysecondskinPreview });
	  };
	
	  WorkTable.prototype.renderColorBox = function renderColorBox() {
	    var _this3 = this;
	
	    var _state2 = this.state,
	        modal = _state2.modal,
	        accessoriesOn = _state2.accessoriesOn;
	    var _props = this.props,
	        isCollection = _props.isCollection,
	        cssModifier = _props.cssModifier,
	        baseBits = _props.baseBits,
	        optionalBits = _props.optionalBits;
	
	
	    var leftArrow = isCollection ? _arrowLeftWhite2.default : _arrowLeft2.default;
	    var rightArrow = isCollection ? _arrowRightWhite2.default : _arrowRight2.default;
	
	    var hasOptionalBits = this.props.optionalBits.length > 0;
	    return _react2.default.createElement(
	      'div',
	      { className: 'color-selector__container' },
	      hasOptionalBits && _react2.default.createElement(
	        'div',
	        { className: 'color-selector__selected__left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'page__text' + cssModifier },
	            'Shell colour \u2013 ',
	            this.optionalColor().name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'page__small-title' + cssModifier },
	            this.currentOptionalBit().name
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'button--round' + cssModifier + ' color-selector__button--checked',
	            onClick: function onClick() {
	              return _this3.setState({ modal: "optionalBits" });
	            }
	          },
	          _react2.default.createElement('div', { style: { backgroundImage: 'url(\'' + this.optionalColor().swatch.resize.src + '\')' } })
	        ),
	        modal === "optionalBits" && this.props.optionalBits.length > 0 && _react2.default.createElement(_ColorSelector2.default, {
	          bits: optionalBits,
	          handleColorChange: function handleColorChange(color, index) {
	            _this3.handleColorChange(index, false);
	          },
	          handleCloseModal: function handleCloseModal() {
	            return _this3.handleCloseModal();
	          },
	          color: this.optionalColor(),
	          slide: this.state.optionalBitIndex,
	          cssModifier: '--tops'
	        })
	      ),
	      (!this.props.collection || this.props.collection.interchangeable) && _react2.default.createElement(
	        'div',
	        { className: 'switch__container' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.accessories', className: 'slider__accessories__title' }),
	        _react2.default.createElement('div', { className: 'switch' + (accessoriesOn ? '--checked' : ''),
	          onClick: function onClick() {
	            return _this3.setState({ accessoriesOn: !accessoriesOn, modal: null });
	          }
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'color-selector__selected__right' + (this.props.optionalBits.length === 0 ? '--alone' : '') },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'button--round' + cssModifier + ' color-selector__button--checked',
	            onClick: function onClick() {
	              return _this3.setState({ modal: "baseBits" });
	            }
	          },
	          _react2.default.createElement('div', { style: { backgroundImage: 'url(\'' + this.baseColor().swatch.resize.src + '\')' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'page__text' + cssModifier },
	            hasOptionalBits ? "Base colour" : "Colour",
	            ' \u2014 ',
	            this.baseColor().name
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'page__small-title' + cssModifier },
	            this.currentBaseBit().name
	          )
	        ),
	        modal === "baseBits" && _react2.default.createElement(_ColorSelector2.default, {
	          bits: baseBits,
	          handleColorChange: function handleColorChange(color, index) {
	            _this3.handleColorChange(index, true);
	          },
	          handleCloseModal: function handleCloseModal() {
	            return _this3.handleCloseModal();
	          },
	          color: this.baseColor(),
	          slide: this.state.baseBitIndex,
	          cssModifier: '--bases'
	        })
	      )
	    );
	  };
	
	  WorkTable.prototype.renderAccessories = function renderAccessories() {
	    var _this4 = this;
	
	    var _state3 = this.state,
	        modal = _state3.modal,
	        accessoriesOn = _state3.accessoriesOn;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      accessoriesOn && this.currentBaseBit().canHaveFeet && this.renderPlus('feet'),
	      accessoriesOn && this.currentOptionalBit().mysecondskinPreview && this.renderPlus('skin'),
	      accessoriesOn && this.currentOptionalBit().softpadPreview && this.renderPlus('pad'),
	      accessoriesOn && this.currentBaseBit().stoolOption && this.renderPlus('stool'),
	      this.props.accessoriesModal.map(function (m) {
	        return m.slug.includes(modal) && _this4.renderAccessoriesModal(modal, m);
	      })
	    );
	  };
	
	  WorkTable.prototype.renderAccessoriesModal = function renderAccessoriesModal(modal, m) {
	    var _this5 = this;
	
	    if (m.slug.includes('diamond') && !this.currentBaseBit().name.toLowerCase().includes('diamond') || m.slug.includes('slice') && !this.currentBaseBit().name.toLowerCase().includes('slice')) {
	      return;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'slider__modal__accessories--' + modal, key: m.slug },
	      _react2.default.createElement('img', {
	        src: _closeCircle2.default,
	        className: 'button--close',
	        onClick: function onClick() {
	          return _this5.handleCloseModal();
	        }
	      }),
	      _react2.default.createElement(
	        'h3',
	        { className: 'slider__modal__accessories__title' },
	        m.title
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'home.designBy' })
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u2013 '
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        m.designers.map(function (d) {
	          return d.name;
	        }).join(', ')
	      ),
	      _react2.default.createElement('img', {
	        className: 'slider__modal__accessories__image',
	        src: m.modalImage.resize.src
	      }),
	      _react2.default.createElement(
	        'a',
	        {
	          className: 'button--dark slider__modal__accessories__link',
	          href: '' + m.link,
	          target: '_blank'
	        },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'collection.findOutMore' })
	      )
	    );
	  };
	
	  WorkTable.prototype.renderPlus = function renderPlus(type) {
	    var _this6 = this;
	
	    return _react2.default.createElement('img', { className: 'slider__modal__accessories__plus--' + type,
	      src: _plus2.default,
	      onClick: function onClick() {
	        return _this6.setState({ modal: '' + type });
	      }
	    });
	  };
	
	  WorkTable.prototype.render = function render() {
	    var _this7 = this;
	
	    var _props2 = this.props,
	        isCollection = _props2.isCollection,
	        collection = _props2.collection;
	    var _state4 = this.state,
	        modal = _state4.modal,
	        accessoriesOn = _state4.accessoriesOn;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.baseColors() && _react2.default.createElement(
	        'div',
	        { style: { position: "relative" } },
	        this.renderAccessories(),
	        _react2.default.createElement(_InterchangeabilitySlider2.default, {
	          isTall: this.props.isTall,
	          baseBitsImages: this.baseColors().map(function (c) {
	            return c.bitImage;
	          }),
	          optionalBitsImages: this.optionalColors().map(function (c) {
	            return c.bitImage;
	          }),
	          changeSlide: function changeSlide(currentBit, isBase) {
	            _this7.handleChangeBit(currentBit, isBase);
	          },
	          isCollection: isCollection,
	          nextTopBit: this.nextOptionalBit(),
	          prevTopBit: this.prevOptionalBit(),
	          nextBaseBit: this.nextBaseBit(),
	          prevBaseBit: this.prevBaseBit()
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'slider__price' },
	          this.productPrice().toFixed(2) + '€'
	        ),
	        modal === 'pad' && _react2.default.createElement(
	          'div',
	          { className: 'slider__accessory__preview' },
	          _react2.default.createElement('img', {
	            src: this.state.padImage
	          })
	        ),
	        modal === 'skin' && _react2.default.createElement(
	          'div',
	          { className: 'slider__accessory__preview' },
	          _react2.default.createElement('img', {
	            src: this.state.skinImage
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'color-selector' },
	        this.renderColorBox(),
	        _react2.default.createElement(
	          _Modal2.default,
	          {
	            visible: modal === 'requestInfo',
	            onClose: function onClose() {
	              return _this7.handleCloseModal();
	            }
	          },
	          _react2.default.createElement(_RequestInfoForm2.default, {
	            product: this.productName(),
	            sku: this.productSku(),
	            price: this.productPrice().toFixed(2) + '€',
	            productUrl: this.productImageUrl(),
	            productImageEmailUrl: this.productImageEmailUrl(),
	            onSubmit: function onSubmit() {
	              return _this7.handleCloseModal();
	            }
	          })
	        ),
	        collection && _react2.default.createElement(
	          _Modal2.default,
	          {
	            visible: modal === 'requestModel',
	            onClose: function onClose() {
	              return _this7.handleCloseModal();
	            }
	          },
	          _react2.default.createElement(_RequestModelForm2.default, {
	            collectionName: collection.name,
	            collectionId: collection.id.match(/[0-9]+/)[0],
	            onSubmit: function onSubmit() {
	              return _this7.handleCloseModal();
	            }
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'buttons__container' },
	        collection && collection.dataSheet && _react2.default.createElement(
	          'a',
	          {
	            href: collection.dataSheet.url, download: true,
	            target: '_blank',
	            className: 'button--dark'
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.sheet' })
	        ),
	        _react2.default.createElement(
	          'button',
	          { className: 'button--red', onClick: function onClick() {
	              return _this7.setState({ modal: 'requestInfo' });
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.iWantThis' })
	        ),
	        collection && collection.instructionManual && _react2.default.createElement(
	          'a',
	          {
	            href: collection.instructionManual.url, download: true,
	            target: '_blank',
	            className: 'button--dark'
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.manual' })
	        ),
	        false && collection && collection.threesixty && _react2.default.createElement(
	          'button',
	          { className: 'button--dark', onClick: function onClick() {
	              return _this7.setState({ modal: 'requestModel' });
	            } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.request3dModel' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'buttons__container' },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.productShareUrl()),
	            target: '_blank',
	            className: 'page__text--dark'
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'workTable.share' })
	        )
	      )
	    );
	  };
	
	  return WorkTable;
	}(_react2.default.Component);
	
	exports.default = WorkTable;
	module.exports = exports['default'];

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctY2lyY2xlLWxlZnQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjc2LjAwMDAwMCwgLTI3NS4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY4MC4wMDAwMDAsIDI3OS4wMDAwMDApIj4KICAgICAgICAgICAgPHBhdGggZD0iTTI1Mi4wMDA0OTIsNTA0IEMxMTIuODIzMzc3LDUwNCAwLDM5MS4xNzU4NTkgMCwyNTIgQzAsMTEyLjgyNDE0MSAxMTIuODIzMzc3LDAgMjUyLjAwMDQ5MiwwIEMzOTEuMTc1NjM5LDAgNTA0LDExMi44MjQxNDEgNTA0LDI1MiBDNTA0LDM5MS4xNzU4NTkgMzkxLjE3NTYzOSw1MDQgMjUyLjAwMDQ5Miw1MDQgWiIgaWQ9ImFycm93LWNpcmNsZS1kb3duLWNvcHkiIGZpbGw9IiMzMzMzMzMiPjwvcGF0aD4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1MS4wMDAwMDAsIDExMC4wMDAwMDApIiBmaWxsPSIjRkZGRkZGIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLUNvcHkiIHBvaW50cz0iMTI3LjQzNjI0OSAwIDE0OS43NzEyOTMgMjAuMDI3IDQwLjI5NTA3ODcgMTQyLjExNSAxNDkuNzcxMjkzIDI2NC4yMDMgMTI3LjQzNjI0OSAyODQuMjMgMi4yNzM3MzY3NWUtMTMgMTQyLjExNSI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctY2lyY2xlLXJpZ2h0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAwNi4wMDAwMDAsIC0yNzUuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9Ikdyb3VwLTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMTAuMDAwMDAwLCAyNzkuMDAwMDAwKSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNTIuMDAwNDkyLDUwNCBDMTEyLjgyMzM3Nyw1MDQgMCwzOTEuMTc1ODU5IDAsMjUyIEMwLDExMi44MjQxNDEgMTEyLjgyMzM3NywwIDI1Mi4wMDA0OTIsMCBDMzkxLjE3NTYzOSwwIDUwNCwxMTIuODI0MTQxIDUwNCwyNTIgQzUwNCwzOTEuMTc1ODU5IDM5MS4xNzU2MzksNTA0IDI1Mi4wMDA0OTIsNTA0IFoiIGlkPSJhcnJvdy1jaXJjbGUtZG93bi1jb3B5IiBmaWxsPSIjMzMzMzMzIj48L3BhdGg+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLUNvcHkiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjI1LjU2Mzc1MSAxMTAgMzUzIDI1Mi4xMTUgMjI1LjU2Mzc1MSAzOTQuMjMgMjAzLjIyODcwNyAzNzQuMjAzIDMxMi43MDQ5MjEgMjUyLjExNSAyMDMuMjI4NzA3IDEzMC4wMjciPjwvcG9seWdvbj4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctbGVmdC13aGl0ZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2NzYuMDAwMDAwLCAtMTQ1NS4wMDAwMDApIj4KICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xMi1Db3B5LTUiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjAyNi43MzU1MyAxOTY3IDE3OTcgMTcxMSAyMDI2LjczNTUzIDE0NTUgMjA2NyAxNDkxLjA3NTggMTg2OS42NDE5IDE3MTEgMjA2NyAxOTMwLjkyNDIiPjwvcG9seWdvbj4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctbGVmdDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2NzYuMDAwMDAwLCAtODgwLjAwMDAwMCkiPgogICAgICAgIDxwb2x5Z29uIGlkPSJGaWxsLTEyLUNvcHkiIGZpbGw9IiMzMzMzMzMiIHBvaW50cz0iMjAyNi41NTc4NyAxMzkyIDE3OTcgMTEzNiAyMDI2LjU1Nzg3IDg4MCAyMDY2Ljc5MTIgOTE2LjA3NTc5OCAxODY5LjU4NTcyIDExMzYgMjA2Ni43OTEyIDEzNTUuOTI0MiI+PC9wb2x5Z29uPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctcmlnaHQtd2hpdGU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDA2LjAwMDAwMCwgLTE0NTUuMDAwMDAwKSI+CiAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTItQ29weS00IiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjExNjcuMjY0NDcgMTk2NyAxMTI3IDE5MzAuOTI0MiAxMzI0LjM1ODEgMTcxMSAxMTI3IDE0OTEuMDc1OCAxMTY3LjI2NDQ3IDE0NTUgMTM5NyAxNzExIj48L3BvbHlnb24+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+YXJyb3ctcmlnaHQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMDA2LjAwMDAwMCwgLTg4MC4wMDAwMDApIj4KICAgICAgICA8cG9seWdvbiBpZD0iRmlsbC0xMiIgZmlsbD0iIzMzMzMzMyIgcG9pbnRzPSIxMTY3LjIzMzMzIDEzOTIgMTEyNyAxMzU1LjkyNDIgMTMyNC4yMDU0NyAxMTM2IDExMjcgOTE2LjA3NTc5OCAxMTY3LjIzMzMzIDg4MCAxMzk2Ljc5MTIgMTEzNiI+PC9wb2x5Z29uPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OSAoNTEwMDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmNyb3NzLWJsYWNrPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFzc2V0cyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDMzMi4wMDAwMDAsIC0yNzUuMDAwMDAwKSIgZmlsbD0iIzMzMzMzMyI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC03LUNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDMzNi4wMDAwMDAsIDI3OS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJJY29uL2Nyb3NzLWJsYWNrIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMjUyLDUwNCBDMTEyLjgyNDI0Myw1MDQgMCwzOTEuMTc1NzU3IDAsMjUyIEMwLDExMi44MjQyNDMgMTEyLjgyNDI0MywwIDI1MiwwIEMzOTEuMTc1NzU3LDAgNTA0LDExMi44MjQyNDMgNTA0LDI1MiBDNTA0LDM5MS4xNzU3NTcgMzkxLjE3NTc1Nyw1MDQgMjUyLDUwNCBaIE0yNTIsNDc4LjE1Mzg0NiBDMzc2LjkwMTMyLDQ3OC4xNTM4NDYgNDc4LjE1Mzg0NiwzNzYuOTAxMzIgNDc4LjE1Mzg0NiwyNTIgQzQ3OC4xNTM4NDYsMTI3LjA5ODY4IDM3Ni45MDEzMiwyNS44NDYxNTM4IDI1MiwyNS44NDYxNTM4IEMxMjcuMDk4NjgsMjUuODQ2MTUzOCAyNS44NDYxNTM4LDEyNy4wOTg2OCAyNS44NDYxNTM4LDI1MiBDMjUuODQ2MTUzOCwzNzYuOTAxMzIgMTI3LjA5ODY4LDQ3OC4xNTM4NDYgMjUyLDQ3OC4xNTM4NDYgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgcG9pbnRzPSIyMzEuMDEwODQyIDI1Ny4xODk0ODMgMTM1LjQ3NTY3NSAxNjAuMDk4ODM4IDE1My40MDMxNDcgMTQxLjQ4MDg1IDI0OS40MjcxMTUgMjM5LjA2ODI1NSAzNDYuNTE3NzYgMTQzLjUzMzA4OCAzNjUuMTM1NzQ3IDE2MS40NjA1NTkgMjY3LjU0ODM0MiAyNTcuNDg0NTI4IDM2My4wODM1MDkgMzU0LjU3NTE3MiAzNDUuMTU2MDM4IDM3My4xOTMxNiAyNDkuMTMyMDcgMjc1LjYwNTc1NSAxNTIuMDQxNDI1IDM3MS4xNDA5MjIgMTMzLjQyMzQzOCAzNTMuMjEzNDUxIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+Y2xvc2U8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzUyLjAwMDAwMCwgLTMxOTMuMDAwMDAwKSI+CiAgICAgICAgPHBhdGggZD0iTTIwMDgsMzM5NS44MjE2OCBMMjIxMC44MjE2OCwzMTkzIEwyMjY0LDMyNDYuMTc4MzIgTDIwNjEuMTc4MzIsMzQ0OSBMMjI2NCwzNjUxLjgyMTY4IEwyMjEwLjgyMTY4LDM3MDUgTDIwMDgsMzUwMi4xNzgzMiBMMTgwNS4xNzgzMiwzNzA1IEwxNzUyLDM2NTEuODIxNjggTDE5NTQuODIxNjgsMzQ0OSBMMTc1MiwzMjQ2LjE3ODMyIEwxODA1LjE3ODMyLDMxOTMgTDIwMDgsMzM5NS44MjE2OCBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiMzMzMzMzMiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OSAoNTEwMDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPnBsdXM8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXNzZXRzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNjk4LjAwMDAwMCwgLTI3NS4wMDAwMDApIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNy1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzAyLjAwMDAwMCwgMjc5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24vcGx1cy1yZWQtZnVsbCI+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTI1Miw1MDQgQzExMi44MjQyNDMsNTA0IDAsMzkxLjE3NTc1NyAwLDI1MiBDMCwxMTIuODI0MjQzIDExMi44MjQyNDMsMCAyNTIsMCBDMzkxLjE3NTc1NywwIDUwNCwxMTIuODI0MjQzIDUwNCwyNTIgQzUwNCwzOTEuMTc1NzU3IDM5MS4xNzU3NTcsNTA0IDI1Miw1MDQgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIiBmaWxsPSIjRDczNjQ4Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkxpbmUiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjMyLjcyODM0MiA5Ny4wOTk2MDA2IDI3MS40Nzk0MSA5Ny4wOTk2MDA2IDI3MS40Nzk0MSA0MDcuNzk5MjU0IDIzMi43MjgzNDIgNDA3Ljc5OTI1NCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJMaW5lIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjQwNy43OTkyNTQgMjMyLjcyODM0MiA0MDcuNzk5MjU0IDI3MS40Nzk0MSA5Ny4wOTk2MDA2IDI3MS40Nzk0MSA5Ny4wOTk2MDA2IDIzMi43MjgzNDIiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/test.0e57b2cd.png";

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WorkTable = __webpack_require__(303);
	
	var _WorkTable2 = _interopRequireDefault(_WorkTable);
	
	var _lodash = __webpack_require__(285);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(52);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _getTransitionStyle = __webpack_require__(30);
	
	var _getTransitionStyle2 = _interopRequireDefault(_getTransitionStyle);
	
	var _PageAnimations = __webpack_require__(59);
	
	var _PageAnimations2 = _interopRequireDefault(_PageAnimations);
	
	var _gatsbySourceDatocms = __webpack_require__(80);
	
	var _IntroInterchangeability = __webpack_require__(598);
	
	var _IntroInterchangeability2 = _interopRequireDefault(_IntroInterchangeability);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Interchangeability = function Interchangeability(_ref) {
	  var data = _ref.data,
	      transition = _ref.transition;
	
	  // const isIntroVisible = transition && !transition.previousPathname
	  var isIntroVisible = true;
	
	  var baseBits = (0, _lodash2.default)(data.collections.edges.map(function (x) {
	    return x.node.combos.map(function (c) {
	      return c.baseBits;
	    }).reduce(function (a, b) {
	      return a.concat(b);
	    }, []).filter(function (bit) {
	      return !bit.draft;
	    });
	  }).reduce(function (a, b) {
	    return a.concat(b);
	  }, []), 'code');
	
	  var optionalBits = (0, _lodash2.default)(data.collections.edges.map(function (x) {
	    return x.node.combos.map(function (c) {
	      return c.optionalBits;
	    }).reduce(function (a, b) {
	      return a.concat(b);
	    }, []).filter(function (bit) {
	      return !bit.draft;
	    });
	  }).reduce(function (a, b) {
	    return a.concat(b);
	  }, []), 'code');
	
	  var status = transition ? transition.status : "entering";
	  var timeout = 600;
	
	  var menuStyle = (0, _getTransitionStyle2.default)(status, 200, 2000, 'menuStyle');
	  var pageAppear = (0, _getTransitionStyle2.default)(status, timeout, isIntroVisible ? 3000 : 0, 'bgAppear');
	  var sectionAppears = (0, _getTransitionStyle2.default)(status, timeout, 1000, 'pageAppearsFromBottom');
	
	  var disappear = (0, _getTransitionStyle2.default)(status, timeout, 3000, 'disappear');
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'intro__overflow--inter', style: disappear },
	      isIntroVisible && _react2.default.createElement(_IntroInterchangeability2.default, { transition: transition, title: data.page.title })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'interchangeability',
	        style: { backgroundColor: data.page.themeColor.hex }
	      },
	      _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, {
	        seo: data.page.seo,
	        favicon: data.site.favicon
	      }),
	      _react2.default.createElement(_PageAnimations2.default, {
	        status: status,
	        timeout: timeout,
	        delay: timeout,
	        color: data.page.themeColor.hex
	      }),
	      _react2.default.createElement(_Menu2.default, {
	        style: menuStyle,
	        hasWhiteLogo: false,
	        data: data
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: sectionAppears },
	        _react2.default.createElement(
	          'div',
	          { className: 'interchangeability__section' },
	          _react2.default.createElement(_WorkTable2.default, {
	            baseBits: baseBits,
	            optionalBits: optionalBits,
	            cssModifier: '--interchangeability',
	            isCollection: false,
	            accessoriesModal: data.accessoriesModal.edges.map(function (x) {
	              return x.node;
	            })
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { data: data })
	  );
	};
	
	exports.default = Interchangeability;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-interchangeability-js-dd071995aff95a27f512.js